module.exports = __webpack_public_path__ + "img/editar.5745ecdd.svg";